import React from 'react';

import { Box, FormHelperText, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FieldArray } from 'formik';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import TextFieldFormik from '../../../../../common/text_field';
import DatePickerFormik from '../../../../../common/date_picker';

const ProductsList = ({ formik, productsListIndex, onlyDelivery }) => {

    const onRemoveProduct = (position) => {
        const productsList = formik?.values?.productsList[productsListIndex];
        const index = productsList?.findIndex(product => product?.position === position);

        if (index !== -1) {
            productsList.splice(index, 1);
            formik.setFieldValue(`productsList.${ productsListIndex }`, productsList);
        }
    };

    const handleArrowKeys = (e, productsListIndex, index, fieldName, formik) => {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            const nextInput = document.querySelector(
                `input[name="productsList.${ productsListIndex }.${ index + 1 }.${ fieldName }"]`
            );
            nextInput?.focus();
        }
        if (e.key === "ArrowUp") {
            e.preventDefault();
            const prevInput = document.querySelector(
                `input[name="productsList.${ productsListIndex }.${ index - 1 }.${ fieldName }"]`
            );
            prevInput?.focus();
        }
    };

    const onFocusHandler = (e) => {
        e.target.select();
    };

    return (
        <FieldArray
            name={ `productsList.${ productsListIndex }` }
            render={ () => {
                const products = formik?.values?.productsList?.[productsListIndex] || [];
                const totalQuantity = products.reduce((sum, item) => sum + (Number(item?.quantity) || 0), 0);
                const totalValue = products.reduce((sum, item) => sum + ((Number(item?.quantity) || 0) * (Number(item?.price) || 0)), 0);

                return (
                    <Box sx={ { display: 'flex', flexDirection: 'column', gap: 1 } }>
                        <TableContainer component={ Paper } variant="outlined" sx={ { backgroundColor: 'background.paper' } }>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                                        <TableCell style={ { width: '5%' } }>Lp.</TableCell>
                                        <TableCell>Nazwa</TableCell>
                                        <TableCell align="center" style={ { width: '12%' } }>Liczba szt.</TableCell>
                                        <TableCell align="center" style={ { width: '25%' } }>Data przydatności</TableCell>
                                        {
                                            !onlyDelivery &&
                                            <TableCell align="center" style={ { width: '15%' } }>Cena zakupu
                                                [netto]</TableCell>
                                        }
                                        <TableCell align="center" style={ { width: '5%' } }>Usuń</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        products.map((product, index) => (
                                            <TableRow
                                                key={ product?.position ?? index }
                                                hover
                                            >
                                                <TableCell>{ index + 1 }</TableCell>
                                                <TableCell>
                                                    <TextFieldFormik
                                                        name={ `productsList.${ productsListIndex }.${ index }.name` }
                                                        size="small"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextFieldFormik
                                                        name={ `productsList.${ productsListIndex }.${ index }.quantity` }
                                                        size="small"
                                                        type="number"
                                                        inputProps={ { min: '1', step: '1' } }
                                                        onKeyDown={ (e) => handleArrowKeys(e, productsListIndex, index, 'quantity', formik) }
                                                        onFocus={ onFocusHandler }
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <DatePickerFormik
                                                        name={ `productsList.${ productsListIndex }.${ index }.expirationDate` }
                                                        size="small"
                                                        disabled={ onlyDelivery }
                                                        InputLabelProps={ { shrink: true } }
                                                    />
                                                </TableCell>
                                                {
                                                    !onlyDelivery &&
                                                    <TableCell align="center">
                                                        <TextFieldFormik
                                                            name={ `productsList.${ productsListIndex }.${ index }.price` }
                                                            size="small"
                                                            type="number"
                                                            inputProps={ { min: '0.01', max: '100.00', step: '0.01' } }
                                                            onKeyDown={ (e) => handleArrowKeys(e, productsListIndex, index, 'price', formik) }
                                                            onFocus={ onFocusHandler }
                                                        />
                                                    </TableCell>
                                                }
                                                <TableCell align="center">
                                                    <IconButton
                                                        onClick={ () => onRemoveProduct(product?.position) }
                                                        title="Usuń z listy">
                                                        <RemoveCircleIcon/>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }

                                    {products.length > 0 && (
                                        <TableRow sx={{ '& td': { color: 'text.secondary', fontSize: '0.85rem', borderBottom: 'none' } }}>
                                            <TableCell colSpan={2} align="right">
                                                Suma:
                                            </TableCell>
                                            <TableCell align="right" sx={{ fontWeight: 600 }}>
                                                {totalQuantity}
                                            </TableCell>
                                            <TableCell></TableCell>
                                            {
                                                !onlyDelivery &&
                                                <TableCell align="right" sx={{ fontWeight: 600 }}>
                                                    {totalValue.toFixed(2)} PLN
                                                </TableCell>
                                            }
                                            <TableCell></TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <FormHelperText error>
                            <span>
                                {
                                    typeof formik?.errors?.productsList?.[productsListIndex] === 'string' &&
                                    formik?.errors?.productsList[productsListIndex]
                                }
                            </span>
                        </FormHelperText>
                    </Box>
                );
            } }
        />
    );
};

export default ProductsList;